import * as Yup from "yup"
import { AcademicLevel, Availabilities, CampaignId, Campus, Consentement, Email, FirstName, LastName, MobilePhoneRequired, PostalCodeNotRequired } from "services/validation"

const schema = Yup.object().shape({
  ...Availabilities,
  ...CampaignId,
  ...Consentement,
  lead: Yup.object().shape({
    ...AcademicLevel,
    ...Campus,
    ...Email,
    ...FirstName,
    ...LastName,
    ...MobilePhoneRequired,
    ...PostalCodeNotRequired
  })
})

export default schema
